<template>
  <div class="wrapper">
    <top-bar />
    <div
      :class="{
        'no-sidebar': !isSidebarEnabled,
        'sidebar-minimized': isSidebarMinimized,
      }"
      class="page-wrapper"
    >
      <nav-sidebar v-if="isSidebarEnabled" />
      <router-view />
      <cookie-bar />
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/layouts/TopBar'
import NavSidebar from '@/components/layouts/NavSidebar'
import CookieBar from '@/components/CookieBar'

export default {
  name: 'AppLayout',
  components: {
    TopBar,
    NavSidebar,
    CookieBar
  },

  computed: {
    isSidebarMinimized () {
      return this.$store.state.layout.isSidebarMinimized
    },
    isSidebarEnabled () {
      return this.$store.state.layout.isSidebarEnabled
    }

  }

}
</script>

<style lang="scss" scoped>
.wrapper {
  padding-top: 46px;
}

.page-wrapper {
  padding-left: 220px;

  &.sidebar-minimized {
    padding-left: 45px;
  }

  &.no-sidebar {
    padding-left: 0;
  }
}
// .cookie-bar {
//   z-index: 999999;
//   position: fixed;
//   bottom: 0;
//   right: 0;
//   width: 100%;
//   height: 60px;
//   background: rgb(239, 239, 239);

//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding:25px
// }
// .cookie-bar-description{
//   display:flex;
//   align-items: center;
// }
// .accept-cookie-button {
//   background-color: rgb(251, 131, 50);
//   border-radius: 2px;
//   border-style: none;
//  &:hover {
//        background-color: rgb(255, 174, 108);
//     }
// }
</style>
